import {useLocation} from 'react-router-dom';

import {customerRoutes} from '@dms/routes';

import {composePath, useNavigate, useOnMount} from 'shared/web';

import {TelephonyScreenPopLocationState} from '../../../utils/TelephonyScreenPopLocationStateSchema';

interface ScreenPopOnAnswerProps {
  customerId: string;
  callerName: string;
}

/**
 * Renders nothing; on mount opens the customer of the call the viewer just answered, unless the
 * viewer is already there. Mount it with the call id as `key`, once per answered call.
 */
export function ScreenPopOnAnswer(props: ScreenPopOnAnswerProps) {
  const navigate = useNavigate();
  const location = useLocation();

  useOnMount(() => {
    const customerPath = composePath(customerRoutes.detail, {params: {id: props.customerId}});

    if (location.pathname.startsWith(customerPath)) {
      return;
    }

    const state: TelephonyScreenPopLocationState = {
      telephonyScreenPop: {callerName: props.callerName},
    };

    navigate(customerPath, {state});
  });

  return null;
}
